import React, { useState, useEffect } from "react";
import "semantic-ui-css/semantic.min.css";
import { Navigate, Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { FormAlumnos } from "../../../components/Alumnos/FormAlumnos/FormAlumnos";
import { useAuth } from "../../../hook/userAuth";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { Loader } from "semantic-ui-react";
import axios from "axios";

function DatosAlumno() {
  const { auth } = useAuth();
  const location = useLocation();
  const datosAlumno = location.state?.datosAlumno;
  const datosGrupo = location.state?.datosGrupo;
  if (!auth?.me?.es_personal_control_escolar) {
    return <Navigate to={"/"}></Navigate>;
  }
  return (
    <LogicaDatosAlumno datosAlumno={datosAlumno} datosGrupo={datosGrupo} />
  );
}

function LogicaDatosAlumno({ datosAlumno, datosGrupo }) {
  const { auth } = useAuth();
  const [alumno, setAlumno] = useState(null);
  const [refetch] = useState(false);
  const [loading, setLoading] = useState(true);

  async function getAlumnoApi() {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_API}/api/alumno/${datosAlumno.id}/`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      const result = response.data;
      setLoading(false);
      setAlumno(result);
      return result;
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getAlumnoApi();
    // eslint-disable-next-line
  }, [refetch]);

  return (
    <div>
      <h1 className="tituloin">
        Matricula {alumno?.matricula} - {alumno?.apellido_paterno}{" "}
        {alumno?.apellido_materno} {alumno?.nombre}{" "}
      </h1>
      <h6 className="sub">
        <Link to="/Grupos">Grupos</Link> / <Link>Alumnos grupo</Link> /{" "}
        <Link>Datos alumno</Link>
      </h6>

      {loading ? (
        <Loader active inline="centered">
          Cargando....
        </Loader>
      ) : (
        <FormAlumnos alumno={alumno} />
      )}
    </div>
  );
}

export default DatosAlumno;
